/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getBookmarks.defs.js'
export * as $defs from './getBookmarks.defs.js'
